import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MonoTypeOperatorFunction } from 'rxjs';
import { LoaderService } from '../../services/loader';
import { inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NotificationService } from '../../services/notification';
import { FormBuilder, FormGroup } from '@angular/forms';
import { FiltroPersistenteService } from '../../services/filtro-persistente/filtro-persistente.service';

export class BaseComponent {
  router = inject(Router);
  loader = inject(LoaderService);
  fb = inject(FormBuilder);
  activatedRoute = inject(ActivatedRoute);
  notification = inject(NotificationService);
  private filtroPersistente = inject(FiltroPersistenteService);

  private ngTakeUntilDestroyed = takeUntilDestroyed();

  takeUntilDestroyed<T>(): MonoTypeOperatorFunction<T> {
    return this.ngTakeUntilDestroyed as MonoTypeOperatorFunction<T>;
  }

  /**
   * Restaura o filtro salvo desta tela e passa a salvá-lo a cada mudança.
   * Chamar no ngOnInit ANTES de carregar a lista. `chave` = id único da tela.
   */
  protected persistirFiltro(chave: string, form: FormGroup): void {
    this.filtroPersistente.vincular(chave, form, this.takeUntilDestroyed());
  }

  /** Remove o filtro salvo desta tela (chamar junto do reset do "Limpar"). */
  protected limparFiltroPersistido(chave: string): void {
    this.filtroPersistente.limpar(chave);
  }

  getRouteParam(key: string) {
    return this.activatedRoute.snapshot.params[key] as string;
  }

  getRouteQueryParam(key: string) {
    return this.activatedRoute.snapshot.queryParams[key] as string;
  }
}
